import { useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { ConfigMockProps } from '../types/config.type'

export const useConfig = () => {
  const { data: config } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<ConfigMockProps>('/configs')
      return data
    },
    queryKey: ['config']
  })

  return { config }
}
